module.exports = __webpack_public_path__ + "static/media/Exclusive Deals & Offers.536bbddb.webp";